// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import axios from "axios";
import ElementUI from "element-ui"; //全局引入element
import "element-ui/lib/theme-chalk/index.css"; //全局引入element的样式
import Vant from "vant";
import "vant/lib/index.css";
import Vue from "vue";
import Vuex from "vuex";
import App from "./App";
import router from "./router";

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(Vant);
Vue.use(ElementUI);

// 全局属性存储
const store = new Vuex.Store({
  state: {},
  mutations: {}
});
// 配置axios
Vue.prototype.$http = axios;
// 修改AJAX默认地址
// axios.defaults.baseURL = "http://218.202.240.118:8085";
axios.interceptors.request.use(
  function(response) {
    var token = ""; //getCookie("token");
    if (token) {
      response.headers.token = token;
    }
    return response;
  },
  function(error) {
    console.log("网络错误，请刷新重试");
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  res => {
    // if (res.data.code == "403") {
    //   // alert('登录信息已失效，请重新登录');
    // }
    // if (res.data.code != 200) {

    // }
    return res.data;
  },
  err => {
    console.log("网络错误，请刷新重试");
    return err;
  }
);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js